export default __webpack_public_path__ + "static/media/amrakold.a0d60715.png";